import styled from "styled-components";
import { DesignTokens } from "../../styles/design-tokens";

const { spacings, colors } = DesignTokens;

export const DividerLine = styled.div`
  margin: ${spacings.middle}px 0;
  border-bottom: 1px solid ${colors.gray.light};
`;
